module.exports = __webpack_public_path__ + "img/pintecFast.5f9cec18.png";